import React, { useEffect } from 'react';

import styled from 'styled-components';

import { ESpacing } from '@aquariuxfintech/aqx-trader-react-ui/foundation';
import { closeAllPortals } from '@aquariuxfintech/aqx-trader-react-ui/portal';

import { ELoginAs } from '@aqx-core/common/api/auth';
import { ECrmType } from '@aqx-core/common/api/user-account';
import { useAuthLoginAs } from '@aqx-core/common/services/auth';
import { useCompanyProfile } from '@aqx-core/common/services/company';

import LoginForm from './content';
import OtpLoginForm from './content/otp-login';

const LoginScreen: FCC = () => {
  const companyProfile = useCompanyProfile();
  const otpEnabled = companyProfile?.otpEnabled;
  const selectedTab = useAuthLoginAs();

  // Clear all the modal when user go back to login screen
  useEffect(() => {
    return () => {
      closeAllPortals();
    };
  }, []);

  // Show OTP login form only for the first LIVE tab (ELoginAs.LIVE) when OTP is enabled
  // For other tabs (MT4_LIVE, MT5_LIVE, DEMO), show the old login form
  const showOtpForm = otpEnabled && selectedTab === ELoginAs.LIVE;

  return (
    <>
      <StyledLoginContainer>
        {showOtpForm ? <OtpLoginForm crmType={ECrmType.TRADAWISE} /> : <LoginForm />}
      </StyledLoginContainer>
    </>
  );
};

export default LoginScreen;

const StyledLoginContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: ${ESpacing.XL}px;
`;
